import React from "react";
import * as Sentry from "@sentry/browser";
import { useConfig } from "../config";
import { useAuthContext } from "../auth";
export var useFbPixel = function useFbPixel() {
  var config = useConfig();

  var _useAuthContext = useAuthContext(),
      user = _useAuthContext.user;

  return React.useMemo(function () {
    function wrap(fn) {
      var _a, _b, _c, _d, _e;

      try {
        if (typeof window === "undefined") return;
        var fbq = (_b = (_a = window) === null || _a === void 0 ? void 0 : _a.fbq, _b !== null && _b !== void 0 ? _b : function () {});
        return fn(fbq);
      } catch (err) {
        console.error(err);
        (_e = (_c = Sentry) === null || _c === void 0 ? void 0 : (_d = _c).captureException) === null || _e === void 0 ? void 0 : _e.call(_d, err);
      }
    }

    ;

    var track = function track(event, data) {
      wrap(function (fbq) {
        return fbq("track", event, data);
      });
    };

    return {
      viewContent: function viewContent(data) {
        track("ViewContent", data);
      },
      initCheckout: function initCheckout(stripePlanId) {
        var _a;

        track("InitiateCheckout", {
          stripePlanId: stripePlanId,
          userId: (_a = user) === null || _a === void 0 ? void 0 : _a.userId
        });
      },
      startTrial: function startTrial(stripePlanId, currency, amount) {
        track("StartTrial", {
          stripePlanId: stripePlanId,
          value: amount / 100,
          currency: currency.toUpperCase()
        });
      },
      track: track
    };
  }, [config, user]);
};